export default "/images/f4304d4cd4ae3655b4e7dd74b18f06e9.avif";